import {
  PenaltyDetail,
} from '@dapi/sdk';
import {
  sekCurrency,
} from './currency';

export const mockPenaltyDetail: PenaltyDetail = {
  currency: 'SEK',
  decimalPlaces: 0,
  value: 17_246,
  amount: '17246',
  totalTaxes: '22.46',
  taxes: [
    {
      value: 7,
      code: 'XG',
      currencyCode: 'SEK',
      currency: sekCurrency
    },
    {
      value: 14,
      currencyCode: 'SEK',
      currency: sekCurrency,
      code: 'XQ'
    }
  ]
};
